import { render, staticRenderFns } from "./checkAccept.vue?vue&type=template&id=b6ec6044&scoped=true"
import script from "./checkAccept.vue?vue&type=script&lang=js"
export * from "./checkAccept.vue?vue&type=script&lang=js"
import style0 from "./checkAccept.vue?vue&type=style&index=0&id=b6ec6044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ec6044",
  null
  
)

export default component.exports